import { Controller } from '@hotwired/stimulus'
import {
  analyticsDisabled,
  kelvinAnalytics,
  pageProperties,
  respectingConsent
} from '../lib/tracking_utils'

export default class extends Controller {
  static values = {
    eventName: String,
    properties: { type: Object, default: {} }
  }

  connect () {
    this.openedAt = Date.now()
  }

  track () {
    if (!this.eventNameValue || analyticsDisabled()) return

    respectingConsent(async () => {
      const analytics = await kelvinAnalytics()
      analytics.track(this.eventNameValue, {
        ...pageProperties(),
        ...this.propertiesValue,
        duration_seconds: Math.round((Date.now() - this.openedAt) / 1000)
      })
    })
  }
}
